/**
 * These React components are used to indicate correct and wrong answers in the interactions
 */

import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../services/i18nService';
import storeManager from '../../../store/StoreManager';

/* eslint-disable max-len */
const iconAnsweredCorrect = 'data:image/svg+xml;base64,PHN2ZyBpZD0iYW5zd2VyZWRfY29ycmVjdCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDAgNDAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMzU4ZDE0O30uY2xzLTJ7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+QXJ0Ym9hcmQgMTwvdGl0bGU+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSIyMCIgY3k9IjIwIiByPSIyMCIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTMwLjUxLDE3LjA2bC05LjcsOS43TDE5LDI4LjU4YTEuMjksMS4yOSwwLDAsMS0xLjgyLDBsLTEuODItMS44Mi00Ljg1LTQuODVhMS4yOSwxLjI5LDAsMCwxLDAtMS44MmwxLjgyLTEuODJhMS4yOSwxLjI5LDAsMCwxLDEuODIsMGwzLjk0LDQsOC43OS04LjhhMS4yOSwxLjI5LDAsMCwxLDEuODIsMGwxLjgyLDEuODJhMS4yOSwxLjI5LDAsMCwxLDAsMS44MloiLz48L3N2Zz4=';
const iconAnsweredWrong = 'data:image/svg+xml;base64,PHN2ZyBpZD0iYW5zd2VyZWRfd3JvbmciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQwIDQwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6Izg5MGUxODt9LmNscy0ye2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFydGJvYXJkIDE8L3RpdGxlPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0yOC4wNiwyNS43bC0xLjgyLDEuODJhMS4yOSwxLjI5LDAsMCwxLTEuODIsMGwtMy45NC0zLjk0LTMuOTQsMy45NGExLjI5LDEuMjksMCwwLDEtMS44MiwwTDEyLjg5LDI1LjdhMS4yOSwxLjI5LDAsMCwxLDAtMS44MmwzLjk0LTMuOTRMMTIuODksMTZhMS4yOSwxLjI5LDAsMCwxLDAtMS44MmwxLjgyLTEuODJhMS4yOSwxLjI5LDAsMCwxLDEuODIsMGwzLjk0LDMuOTQsMy45NC0zLjk0YTEuMjksMS4yOSwwLDAsMSwxLjgyLDBsMS44MiwxLjgyYTEuMjksMS4yOSwwLDAsMSwwLDEuODJsLTMuOTQsMy45NCwzLjk0LDMuOTRhMS4yOSwxLjI5LDAsMCwxLDAsMS44MloiLz48L3N2Zz4=';
const iconUnansweredCorrect = 'data:image/svg+xml;base64,PHN2ZyBpZD0iY29ycmVjdCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDAgNDAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO30uY2xzLTJ7ZmlsbDojMzU4ZDE0O308L3N0eWxlPjwvZGVmcz48dGl0bGU+QXJ0Ym9hcmQgMTwvdGl0bGU+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSIyMCIgY3k9IjIwIiByPSIyMCIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTMwLjUxLDE3LjA2bC05LjcsOS43TDE5LDI4LjU4YTEuMjksMS4yOSwwLDAsMS0xLjgyLDBsLTEuODItMS44Mi00Ljg1LTQuODVhMS4yOSwxLjI5LDAsMCwxLDAtMS44MmwxLjgyLTEuODJhMS4yOSwxLjI5LDAsMCwxLDEuODIsMGwzLjk0LDQsOC43OS04LjhhMS4yOSwxLjI5LDAsMCwxLDEuODIsMGwxLjgyLDEuODJhMS4yOSwxLjI5LDAsMCwxLDAsMS44MloiLz48L3N2Zz4=';
const iconUnanswered = 'data:image/svg+xml;base64,PHN2ZyBpZD0iYW5zd2VyZWRfd3JvbmdfY29weSIgZGF0YS1uYW1lPSJhbnN3ZXJlZF93cm9uZyBjb3B5IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fS5jbHMtMntmaWxsOiM4OTBlMTg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxPC90aXRsZT48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjIwIiBjeT0iMjAiIHI9IjIwIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjguMDYsMjUuN2wtMS44MiwxLjgyYTEuMjksMS4yOSwwLDAsMS0xLjgyLDBsLTMuOTQtMy45NC0zLjk0LDMuOTRhMS4yOSwxLjI5LDAsMCwxLTEuODIsMEwxMi44OSwyNS43YTEuMjksMS4yOSwwLDAsMSwwLTEuODJsMy45NC0zLjk0TDEyLjg5LDE2YTEuMjksMS4yOSwwLDAsMSwwLTEuODJsMS44Mi0xLjgyYTEuMjksMS4yOSwwLDAsMSwxLjgyLDBsMy45NCwzLjk0LDMuOTQtMy45NGExLjI5LDEuMjksMCwwLDEsMS44MiwwbDEuODIsMS44MmExLjI5LDEuMjksMCwwLDEsMCwxLjgybC0zLjk0LDMuOTQsMy45NCwzLjk0YTEuMjksMS4yOSwwLDAsMSwwLDEuODJaIi8+PC9zdmc+';
const iconAnsweredPartiallyCorrect = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMTIuNUwxMCAxNS41TDE3IDguNSIgc3Ryb2tlPSIjNTk1OTU5IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMiAyMkMxNy41MjI4IDIyIDIyIDE3LjUyMjggMjIgMTJDMjIgNi40NzcxNSAxNy41MjI4IDIgMTIgMkM2LjQ3NzE1IDIgMiA2LjQ3NzE1IDIgMTJDMiAxNy41MjI4IDYuNDc3MTUgMjIgMTIgMjJaIiBzdHJva2U9IiM1OTU5NTkiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==';
/* eslint-enable max-len */

const OutcomeIcon = ({ isCorrect, isPartiallyCorrect = false, isAttempted, onReady }) => {
    let altText;
    let imgSrc;

    if (isAttempted) {
        if (isCorrect) {
            altText = t('outcome.answeredCorrect');
            imgSrc = iconAnsweredCorrect;
        } else if (isPartiallyCorrect) {
            altText = t('outcome.answeredPartiallyCorrect');
            imgSrc = iconAnsweredPartiallyCorrect;
        } else {
            altText = t('outcome.answeredWrong');
            imgSrc = iconAnsweredWrong;
        }
    } else if (isCorrect) {
        altText = t('outcome.unansweredCorrect');
        imgSrc = iconUnansweredCorrect;
    } else {
        altText = t('outcome.unanswered');
        imgSrc = iconUnanswered;
    }

    const { ui: { direction } } = storeManager.getState();
    const classList = ['interaction-outcome-indicator'];
    if (direction === 'rtl') {
        classList.push('indicator-direction-rtl');
    }

    return (
        <img
            className={classList.join(' ')}
            src={imgSrc}
            alt={altText}
            onLoad={onReady}
        />
    );
};

OutcomeIcon.propTypes = {
    isCorrect: PropTypes.bool.isRequired,
    isPartiallyCorrect: PropTypes.bool,
    isAttempted: PropTypes.bool.isRequired,
    onReady: PropTypes.func,
};

export default OutcomeIcon;
